import { render, staticRenderFns } from "./ProductButtonSimilar.vue?vue&type=template&id=86b84888&"
import script from "./ProductButtonSimilar.vue?vue&type=script&lang=js&"
export * from "./ProductButtonSimilar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports